<div class="page-overlay" (click)="handleOutsideClick()" [ngClass]="isVisible ? 'visible' : 'hidden'" appSwipe (swipedown)="handleCloseClick()">
  <div class="widget-container" [class.large]="size === 'large'" (click)="$event.stopPropagation()">
    <div class="widget-header">
      <i-tabler *ngIf="iconName" [name]="iconName!"></i-tabler>
      <span class="title">{{title}}</span>
      <i class="fas fa-xmark-circle" (click)="handleCloseClick()"></i>
    </div>
    <div class="dynamic-content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>